import React from 'react';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Icons
import { IoMdSearch } from 'react-icons/io';
// Slices
import {
	setJobs,
	setQueryJobs,
	setIsLoadingJobs,
	setIsLoadingMoreJobs,
	searchNewData,
	setMoreDataAvailable,
	setPageJobs,
	setQueryJobsFetched,
	setRemoteJob,
	setNextPage,
} from '../../app/features/jobsSlice';
// Services
import { getJobs, normalizeJobsResponse } from '../../services/getJobs';
// Styles
import './JobsSearchBar.css';
// Utils
import { isTokenExpired } from '../../utils/isTokenExpired';
import { updateToken } from '../../utils/updateToken';
// Translate
import { useTranslation } from 'react-i18next';

const JobsSearchBar = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { queryJobs } = useSelector((state) => state.jobs);
	const { institutionCode } = useSelector((state) => state.institution);

	const searchData = async (query, page) => {
		if (query?.length > 0) {
			if (isTokenExpired(localStorage.expires_in)){
				await updateToken();
			}
			dispatch(setIsLoadingJobs(true));
			dispatch(searchNewData());
			dispatch(setRemoteJob(0));
			await getJobs(query, page, 0, institutionCode)
				.then((response) => {
					if (response.status === 200) {
						const jobsResponse = normalizeJobsResponse(response);
						dispatch(setJobs(jobsResponse.data));
						dispatch(setNextPage(jobsResponse.next_page));
						dispatch(setQueryJobsFetched(query));
						dispatch(setPageJobs(jobsResponse.page));
						dispatch(setMoreDataAvailable(jobsResponse.data.length > 0));
						dispatch(setIsLoadingJobs(false));
						dispatch(setIsLoadingMoreJobs(false));
					} else {
						console.error(`Request error. HTTP status: ${response.status}`);
						dispatch(setQueryJobsFetched(query));
						dispatch(setIsLoadingJobs(false));
						dispatch(setIsLoadingMoreJobs(false));
					}
				})
				.catch((error) => {
					console.error('Request error:', error);
					dispatch(setQueryJobsFetched(query));
					dispatch(setIsLoadingJobs(false));
					dispatch(setIsLoadingMoreJobs(false));
				});
		}
	};

	return (
		<form
			className='metasearchBarContainer'
			onSubmit={(e) => {
				e.preventDefault();
				searchData(queryJobs, 1);
			}}
		>
			<input
				placeholder={
					t('Do a job search')
				}
				className='metasearchBar'
				type='text'
				value={queryJobs}
				onChange={(e) => dispatch(setQueryJobs(e.target.value))}
			></input>

			<button className='metasearchButton' type='submit'>
				<p>{t('Search')}</p>
				<IoMdSearch />
			</button>
		</form>
	);
};

export default JobsSearchBar;
